module.exports = __webpack_public_path__ + "static/img/bg1_home.7a018cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg1_home.jpg
// module id = X4xN
// module chunks = 1